import { Clock } from "lucide-react";
import { fmtEUR, formatEU } from "./formatters";

/**
 * RentalSummaryBox — encapsulated luxury summary card shared between
 * BookingModal Step 1 and Step 2. Two-column flex on ≥sm, stacked on
 * mobile. `compact` variant drops paddings for the review section.
 */
export default function RentalSummaryBox({ form, days, grandTotal, testId, compact = false }) {
  const rootCls = compact
    ? "bg-neutral-50 border border-neutral-200/80 rounded-xl p-3 mt-2"
    : "bg-neutral-50 border border-neutral-200/80 rounded-xl p-3.5 mt-3 mb-1";
  return (
    <div className={rootCls} data-testid={testId}>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div className="space-y-1 min-w-0" data-testid={`${testId}-legs`}>
          <p className="text-xs md:text-sm text-neutral-700 font-medium flex items-center gap-2">
            <span className="w-14 shrink-0 text-[10px] uppercase tracking-widest text-neutral-500">Pickup</span>
            <span className="tabular-nums">{formatEU(form.pickup_date)} {form.pickup_time}</span>
            <span className="text-neutral-400">·</span>
            <span className="truncate">{form.pickup_loc || "—"}</span>
          </p>
          <p className="text-xs md:text-sm text-neutral-700 font-medium flex items-center gap-2">
            <span className="w-14 shrink-0 text-[10px] uppercase tracking-widest text-neutral-500">Return</span>
            <span className="tabular-nums">{formatEU(form.return_date)} {form.return_time}</span>
            <span className="text-neutral-400">·</span>
            <span className="truncate">{form.return_loc || "—"}</span>
          </p>
        </div>
        <div className="sm:text-right border-t sm:border-t-0 sm:border-l border-neutral-200/80 sm:pl-4 pt-2 sm:pt-0" data-testid={`${testId}-total`}>
          <p className="text-sm font-semibold text-neutral-900 flex items-center sm:justify-end gap-1">
            <Clock size={12} /> {days} {days === 1 ? "day" : "days"}
          </p>
          {grandTotal != null && (
            <p className="mt-0.5">
              <span className="text-[10px] uppercase tracking-widest text-neutral-500">Total</span>
              <span className="ml-2 text-lg font-bold text-neutral-900 tabular-nums" data-testid={`${testId}-amount`}>
                {fmtEUR(grandTotal)}
              </span>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
